import crudHandlers from './_crud'

export default (state, action) => {
	state = crudHandlers(state, action, 'module_group_rel')
	return state
}
